import ProductosCategoria   from "../views/modulos/almacen/productocategoria/List.vue";
import Proveedores          from "../views/modulos/almacen/proveedor/List.vue";
import UnidadesMaterial     from "../views/modulos/almacen/unidadmaterial/List.vue";
import SubUnidadesMaterial  from "../views/modulos/almacen/subunidadmaterial/List.vue";
import Materiales           from "../views/modulos/almacen/material/List.vue";
import Herramientas         from "../views/modulos/almacen/herramienta/List.vue";
import Insumos              from "../views/modulos/almacen/insumo/List.vue";
import Presentaciones       from "../views/modulos/almacen/presentacion/List.vue";
import PresentacionesForm   from "../views/modulos/almacen/presentacion/Form.vue";
import Productos            from "../views/modulos/almacen/producto/List.vue";
import ProductosPresentaciones from "../views/modulos/almacen/productoPresentacion/List.vue";
import ProductosPresentacionesForm from "../views/modulos/almacen/productoPresentacion/Form.vue";
import Requisiciones        from "../views/modulos/almacen/requisicion/List.vue";
import RequisicionesForm    from "../views/modulos/almacen/requisicion/Form.vue";
import OrdenesCompra        from "../views/modulos/almacen/ordenCompra/List.vue";
import OrdenesCompraForm    from "../views/modulos/almacen/ordenCompra/Form.vue";
import Entradas             from "../views/modulos/almacen/entrada/List.vue";
import EntradasForm         from "../views/modulos/almacen/entrada/Form.vue";
import SolicitudSalida      from "../views/modulos/almacen/solicitudSalida/List.vue";
import SolicitudSalidaForm  from "../views/modulos/almacen/solicitudSalida/Form.vue";
import SolicitudInventario  from "../views/modulos/almacen/inventario/List.vue";
import SolicitudInventarioForm  from "../views/modulos/almacen/inventario/Form.vue";
import InventarioDetalle  from "../views/modulos/almacen/inventario/Detalle.vue";

import SolicitudAlmacen from "../views/modulos/almacen/solicitud/List.vue";
import SolicitudAlmacenForm from "../views/modulos/almacen/solicitud/Form.vue";
import SolicitudSalidaExtraForm from "../views/modulos/almacen/solicitud/solicitudextra/Form.vue";

const VarRutasAlmacen=[
    {
        path: '/ProductoCategoria',
        name: 'ProductoCategoria',
        component: ProductosCategoria,
        props: true
    }, {
        path: '/Proveedor',
        name: 'Proveedor',
        component: Proveedores,
        props: true
    }, {
        path: '/UnidadMaterial',
        name: 'UnidadMaterial',
        component: UnidadesMaterial,
        props: true
    }, {
        path: '/SubUnidadMaterial',
        name: 'SubUnidadMaterial',
        component: SubUnidadesMaterial,
        props: true
    }, {
        path: '/material',
        name: 'material',
        component: Materiales,
        props: true
    },{
        path: '/herramienta',
        name: 'herramienta',
        component: Herramientas,
        props: true
    }, {
        path: '/insumo',
        name: 'insumo',
        component: Insumos,
        props: true
    }, {
        path: '/presentacion',
        name: 'presentacion',
        component: Presentaciones,
        props: true
    }, {
        path: '/presentacionform',
        name: 'presentacionform',
        component: PresentacionesForm,
        props: true
    }, {
        path: '/Producto',
        name: 'Producto',
        component: Productos,
        props: true
    }, {
        path: '/ProductoPresentacion',
        name: 'productopresentacion',
        component: ProductosPresentaciones,
        props: true
    }, {
        path: '/ProductoPresentacionForm',
        name: 'ProductoPresentacionForm',
        component: ProductosPresentacionesForm,
        props: true
    }, {
        path: '/Requisicion',
        name: 'Requisicion',
        component: Requisiciones,
        props: true
    }, {
        path: '/RequisicionForm',
        name: 'RequisicionForm',
        component: RequisicionesForm,
        props: true
    }, {
        path: '/OrdenCompra',
        name: 'OrdenCompra',
        component: OrdenesCompra,
        props: true
    }, {
        path: '/OrdenCompraForm',
        name: 'OrdenCompraForm',
        component: OrdenesCompraForm,
        props: true
    }, {
        path: '/Entrada',
        name: 'Entrada',
        component: Entradas,
        props: true
    }, {
        path: '/EntradaForm',
        name: 'EntradaForm',
        component: EntradasForm,
        props: true
    },  {
        path: '/SolicitudAlmacen',
        name: 'solicitudalmacen',
        component: SolicitudAlmacen,
        props: true
    }, {
        path: '/SolicitudAlmacenForm',
        name: 'solicitudalmacenForm',
        component: SolicitudAlmacenForm,
        props: true
    },{
        path: '/SolicitudSalidaExtraForm',
        name: 'solicitudsalidaextraForm',
        component: SolicitudSalidaExtraForm,
        props: true
    },

    {
        path: '/SolicitudAlmacen2',
        name: 'solicitudSalida',
        component: SolicitudSalida,
        props: true
    },
    {
        path: '/SolicitudAlmacenForm2',
        name: 'solicitudSalidaForm',
        component: SolicitudSalidaForm,
        props: true
    },
    {
        path: '/Inventarios',
        name: 'inventario',
        component: SolicitudInventario,
        props: true
    },
    {
        path: '/InventariosForm',
        name: 'inventarioForm',
        component: SolicitudInventarioForm,
        props: true
    },
    {
        path: '/InventarioDesgloce',
        name: 'inventariodetalle',
        component: InventarioDetalle,
        props: true
    },

]
export default {
    VarRutasAlmacen,
}